import { Controller } from "@hotwired/stimulus"

// Monat / Zeitraum switch on the Baustellen-PDF export form.
//
// The inactive half must be DISABLED, not just hidden: the server prefers an explicit
// start/end range over the year/month selects, so a left-behind pair of range fields
// silently overrides the chosen month. Disabling is done by sweeping the container rather
// than by per-field targets, because a date field is a Common::DateFieldComponent — a
// visible text input, a calendar trigger button and a hidden input carrying the form value,
// all three of which have to be switched together.
export default class extends Controller {
  static targets = ["year", "month", "modeMonth", "modeRange", "monthFields", "rangeFields"]

  connect() {
    this.applyMode()
  }

  toggle() {
    if (!this.hasYearTarget || !this.hasMonthTarget) return
    const allMonths = this.yearTarget.value === "all"
    this.monthTarget.disabled = allMonths
    this.monthTarget.classList.toggle("opacity-50", allMonths)
    this.monthTarget.classList.toggle("cursor-not-allowed", allMonths)
  }

  switchMode() {
    this.applyMode()
  }

  applyMode() {
    if (!this.hasModeRangeTarget || !this.hasModeMonthTarget) return

    const rangeMode = this.modeRangeTarget.checked

    if (this.hasMonthFieldsTarget) this.toggleSection(this.monthFieldsTarget, !rangeMode)
    if (this.hasRangeFieldsTarget) this.toggleSection(this.rangeFieldsTarget, rangeMode)

    // After the sweep, so "Alle Monate" keeps the month select disabled in month mode.
    if (!rangeMode) this.toggle()
  }

  toggleSection(container, active) {
    container.classList.toggle("hidden", !active)
    container.querySelectorAll("input, select, button").forEach((element) => {
      element.disabled = !active
    })
  }
}
